module.exports = __webpack_public_path__ + "static/media/bg-btn-world-map.eeb06770.svg";